export default __webpack_public_path__ + "static/media/BE.d1ca805a.svg";